<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :custom-class="customClass" :center="dialogConsole" :lock-scroll="false" :before-close="DialogClose" v-loading='disabled'>
    <div class="dialogData" v-if="list!=null">
      <div v-if="dialogType==0">
        <div class="make_price_box">{{$t('colon.buyPrice')}} <span class="make_p">{{areaSymbol}} {{list.USD_Price}}</span></div>
        <div class="make_price_box">{{$t('base.yourOffer')}}</div>
        <!-- <div class="make_price_box">$<el-input class="detail_ipt make_ipt" v-model.number="input" type="number" @keydown.native="e=>e.returnValue=(['e','E','-','+'].includes(e.key))?false:e.returnValue" oninput="if(value>=10**3){value=value.slice(0,9)};if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+9)}"></el-input>
        </div> -->
        <div class="make_price_box">{{areaSymbol}}<el-input class="detail_ipt make_ipt" :style="input.length>4?'width:'+(input.length*22)+'px':''" v-model="input" type="text" @input="isInput()"></el-input>
        </div>
        <el-input type="textarea" :placeholder="$t('base.messageOptional')" :rows="5" v-model="textarea" maxlength="250" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
      </div>
      <div v-if="dialogType==1">
        <div v-if="isReview==0">
          <ul class="Reviewoffer">
            <li>
              <div>{{$t('colon.offer')}}</div>
              <div>
                <div>{{areaSymbol}} {{input}}</div>
              </div>
            </li>
            
          </ul>
          <p class="text_gray review_p" v-if="$store.state.lang!='ko'">{{ $t('base.byClicking') }} <span style="font-size:14px;font-weight: bold;">"{{ $t('base.sendOffer') }}"</span>{{ $t('alert.bargainTip') }}</p>
          <p class="text_gray review_p" v-if="$store.state.lang=='ko'">오퍼를 보내시면, 제안이 수락 될 시 이 상품을 구매하는 데 동의하게 되며 2일 이내에 결제해야 합니다. 판매자는 48시간 내에 응답할 수 있습니다</p>
        </div>
        
      </div>
      
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="review_offer">
        <el-button type="primary" @click="ReviewOffer()" v-if="dialogType==0">{{ $t('base.reviewOffer') }}</el-button>
      </div>
      <el-button @click="dialogConsole=true;MakeOffer()" v-if="dialogType==1">{{ $t('base.editOffer') }}</el-button>
      <el-button type="primary" @click="dialogConsole=false;ReviewAccpted()" v-if="dialogType==1" :disabled="disabled">{{ $t('base.sendOffer') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getInfo, priceExchange } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      disabled: false,
      isReview: 0,
      userInfo: null,
      textarea: '',
      dialogType: 0,
      dialogConsole: true,
      dialogTitle: this.$t('base.makeAnOffer'),
      dialogVisible: this.Visible,
      input: 0,
      customClass: 'dialogBox',
    }
  },
  props: {
    makeVisible: Boolean,
    list: {}
  },
  watch: {
    'makeVisible': {
      handler(val) {
        this.dialogVisible = val
      }
    }
  },
  mounted() {},
  created() {
    this.userInfo = getInfo();
    this.iffalse_dialog()

  },
  methods: {
    isInput(e){
      let make_ipt=this.input.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
      if(make_ipt.indexOf('.')>-1){
        let make_array=make_ipt.split(".")
        if(make_array[0].length>8){
          make_array[0]=make_array[0].slice(0,8)
        }
        make_ipt=make_array.join('.')
      }else{
        if(make_ipt.length>8){
          make_ipt=make_ipt.slice(0,8)
        }
      }
      this.input=make_ipt
    },
    iffalse_dialog() {
      let that = this;
      if (!this.dialogVisible) {
        that.customClass = 'dialogBox'
      }
    },
    // 弹框关闭
    DialogClose(val) {
      this.dialogVisible = false;
      this.dialogConsole = true;
      this.dialogType = 0;
      this.dialogTitle = this.$t('base.makeAnOffer');
      this.customClass = 'dialogBox'
      this.$emit('getDialog', this.dialogVisible)
    },
    MakeOffer() {
      this.dialogType = 0;
      this.dialogTitle = this.$t('base.makeAnOffer');
      this.customClass = 'dialogBox'
    },
    // 显示输入框和文本框
    ReviewOffer() {
      let that = this;
      this.dialogConsole = false;
      this.isReview = 0;
      this.dialogType = 1;
      this.dialogTitle = this.$t('base.reviewYourOffer');
      this.customClass = 'offerdialog'
    },
    // 提交议价内容
    ReviewAccpted() {
      let that = this;
      let ExPrice = priceExchange(this.input);
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, CommodityID: that.list.ID, Price: ExPrice, Remark: that.textarea, Images: '', BargainType: 1 }
      that.disabled = true
      this.$post(this.$interface.BargainAdd, qs.stringify(data)).then(res => {
        if (res.result != 0) {
          that.DialogClose();
          this.$router.push({
            path: '/mycardhobby/offerhistory/' + that.list.ID
          })
        } else {
          that.disabled = false
          this.$message({
            type: 'error',
            message: res.msg
          });
          if (res.msg == that.$t('alert.sold')) {
            that.DialogClose();
          }
        }
        // console.log(res)
      })
    }
  },
  destroyed() {
    this.DialogClose();
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.make_price_box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.Reviewoffer li {
  display: flex;
}

.Reviewoffer li>div:first-child {
  /* width: 35%; */
  margin-right: 12px;
}

.Reviewoffer li>div:last-child {
  width: 65%;
}

/* .Reviewoffer li>div:last-child div {
  margin-bottom: 10px;
} */

.review_p {
  font-size: 14px;
  margin-top: 12px;
}

.error_review_p {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 20px;
}

.dialog_center_p {
  line-height: 1.5;
  text-align: center;
}

.make_ipt {
  width: 91px;
}

.make_p {
  margin-left: 16px;
  ;
}

.el-button .el-button--default {
  border: 1px solid #c8c8c8;
}

/* .dialogData{
  padding-top: 5px;
} */
/deep/ .el-dialog__header {
  line-height: 1;
}

/deep/ .dialogBox .el-dialog__header {
  padding: 30px 16px 16px;
}

/deep/ .offerdialog .el-dialog__header {
  padding: 16px 16px 12px;
}

/deep/ .el-dialog__title {
  line-height: 22px;
}

/deep/ .el-dialog__body {
  padding: 12px 40px;
}

/deep/ .el-dialog__body textarea {
  height: 118px;
}

/deep/ .dialogBox .review_offer {
  padding: 0 4px 28px;
}

/* /deep/ .el-dialog__footer{
  padding-top: 8px;
} */
/deep/ .el-textarea .el-textarea__inner {
  padding: 12px 12px 26px;
  /* line-height: 16.1px; */
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/makeoffer.vue